import React, { useEffect, useState } from "react";
import starIcon from "@public/img/star.svg";
import indifferentGhostIcon from "@public/img/indifferent-ghost.svg";
import loadingGif from "@public/img/loading.gif";
import { Redirect } from "react-router-dom";
import { useParams } from "react-router-dom";
import { appRepo } from "@/repo/app-repo";

export default function Page() {
    const routeParams = useParams<{ id: string }>();
    const id = routeParams.id || "";

    if (isNaN(Number(id))) {
        return <Redirect to="/404" />;
    }

    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        setLoading(true);
        appRepo.verifyWalletPayment(Number(id)).then(res => {
            setLoading(false);
            if (!res.status) {
                setIsSuccess(false);
                setMessage(res.message);
            }
            setIsSuccess(true);
        });
    }, [id]);

    return (
        <div className="w-full min-h-[600px] rounded-xl bg-bg2 p-4 flex flex-col gap-4">
            <h2 className="font-bold text-2xl">شارژ کیف پول</h2>

            {loading && <img src={loadingGif} alt="loading" className="m-auto" />}

            {!loading && (
                <div className="flex-1 flex flex-col items-center justify-center gap-4">
                    <img src={isSuccess ? starIcon : indifferentGhostIcon} alt="success" />
                    <p className="text-2xl font-extrabold text-white text-center">
                        <span className={`${isSuccess ? "text-lime-400" : "text-red-500"}`}>
                            {isSuccess ? "شارژ کیف پول" : "مشکلی"}
                        </span>
                        &nbsp;{isSuccess ? "با موفقیت انجام شد" : "در شارژ کیف پول ایجاد شد!"}
                    </p>
                    <p className="text-xl text-center">{message}</p>
                </div>
            )}
        </div>
    );
}